export const loaderInitialState = {
  loading: 0
};

export const loaderActions = {
  increment: (state: any) => ({ ...state, loader: state.loader + 1 }),
  decrement: (state: any) => ({ ...state, loader: state.loader - 1 }),
  default: (state: any) => ({ ...state, loader: 0 })
};
